import React from 'react';
import classes from './PostCardMediaPreviewGoogle.module.scss';
import { SocialProfileWithBoards } from '../../../../hooks/useCategoriesProfilesWithBoards';
import { PostCardPreviewMediaDataType } from '../PostCardMediaPreview/PostCardMediaPreview.view';
import { serializeText, serializeTextToHtml } from '../../TextEditor/helpers/serializer';
import { SocialProfile } from '../../../../components/socialProfiles/SocialProfile';
import { SocialNetworksEnum } from '../../../../constants/social-networks';
import classNames from 'classnames';
import {
  LinkGoogleCallToAction,
  Network,
  PostMultiMediaAttachMode,
  SocialOAuthProvider
} from '../../../../models/graphql';
import { mapLinkGoogleButtonToLabel } from '../../GoogleButtonBlock/GoogleButtonBlock.view';
import { InvalidMediaSet } from '../PostCardMediaPreview/InvalidMediaSet';
import { SingularValidator } from '../../validators/helpers/singular-validator';

export type PostCardMediaPreviewGoogleProfile = {
  socialProfile: SocialProfileWithBoards & { __typename: 'GoogleSocialProfile' };
  buttonType: LinkGoogleCallToAction;
};

export type PostCardMediaPreviewGoogleViewProps = PostCardPreviewMediaDataType & PostCardMediaPreviewGoogleProfile;

const googleMinMediaWidth = 645;

export const PostCardMediaPreviewGoogleView = (props: PostCardMediaPreviewGoogleViewProps): JSX.Element => {
  const { text, media, socialProfile, link, buttonType } = props;
  const serializedText = serializeText(text);
  const hasText = !!serializedText;
  const wrapperClasses = classNames(classes.SocialProfileWrapper, {
    [classes.SocialProfileWrapperNoContent]:
      !media.length && !hasText && (!link || buttonType === LinkGoogleCallToAction.NONE)
  });

  const originalImageWidth = media.length ? media[0].width : googleMinMediaWidth;
  let imageWidthPercents = 100;
  const invalidMedia =
    SingularValidator.noMixedMediaInvalid(media, PostMultiMediaAttachMode.MULTIPLE) ||
    SingularValidator.noVideosAllowedInvalid(media) ||
    SingularValidator.noGifsAllowedInvalid(media) ||
    SingularValidator.googleMinMediaInvalid(media) ||
    SingularValidator.googleMediaLimitInvalid(media, PostMultiMediaAttachMode.MULTIPLE);
  if (originalImageWidth < googleMinMediaWidth) {
    imageWidthPercents = (originalImageWidth * 100) / googleMinMediaWidth;
  }
  return (
    <>
      <div className={wrapperClasses}>
        <SocialProfile
          socialProfile={{
            id: socialProfile.id,
            provider: SocialOAuthProvider.GOOGLE,
            network: Network.GOOGLE,
            name: socialProfile.displayName,
            type: ''
          }}
          disconnected={!socialProfile.connected}
          sublabel={true}
          size={'medium'}
          label={true}
          image={socialProfile.photoUrl}
        />
      </div>
      {media.length ? (
        invalidMedia ? (
          <InvalidMediaSet className={classNames(classes.NoContent, classes.MediaWrapper)} />
        ) : (
          <div className={classNames(classes.MediaWrapper)}>
            <img src={media[0].url} alt={'google'} style={{ maxWidth: `${imageWidthPercents}%` }} />
          </div>
        )
      ) : null}
      {hasText ? (
        <div
          className={classes.TextWrapper}
          dangerouslySetInnerHTML={{ __html: serializeTextToHtml(text, SocialNetworksEnum.google) }}></div>
      ) : null}
      {buttonType !== LinkGoogleCallToAction.NONE && link ? (
        <div className={classNames(classes.ButtonWrapper, 'grid-x', 'cell', 'shrink')}>
          <div className={classes.Button}>{mapLinkGoogleButtonToLabel(buttonType)}</div>
        </div>
      ) : null}
    </>
  );
};
